// import { Injectable } from '@angular/core';
// import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
// import { Observable, throwError } from 'rxjs';
// import { catchError, map } from 'rxjs/operators';
// import { CoreGymService } from '../core.gym.service.service';

// /**
//  * AccountService (login.service.ts)
//  *
//  * REFERENCE service that login.component.ts imports. It follows your established pattern:
//  *     url = coreGymService.BaseUrl + coreGymService.serviceUrls['<Key>']
//  *
//  * IMPORTANT: you very likely already HAVE a login.service.ts / AccountService in your project.
//  * If so, MERGE the login() + OTP + reset methods below into it rather than replacing it, and
//  * keep your real CoreGymService injection. This file exists so the package compiles standalone
//  * and shows the exact method shapes login.component.ts expects.
//  *
//  * Add these keys to your serviceUrls config:
//  *   'LoginUrl'          : 'api/auth/login'          (or your GetABGTechnologysAccountLogin endpoint)
//  *   'SendOtpUrl'        : 'api/auth/verify/send'
//  *   'VerifyOtpUrl'      : 'api/auth/2fa/verify'
//  *   'ForgotPasswordUrl' : 'api/auth/forgot-password'
//  *   'ResetPasswordUrl'  : 'api/auth/reset-password'
//  */
// @Injectable({ providedIn: 'root' })
// export class LoginService {

//   // Replace `any` with your real CoreGymService type and inject it as you do elsewhere.
//   constructor(
//     private readonly http: HttpClient,
//     private readonly coreGymService: CoreGymService
//   ) { }

//   /** POST /api/auth/login -> { accessToken, refreshToken, user }. */
//   login(email: string, password: string, rememberMe: boolean = false): Observable<any> {
//     const headers = new HttpHeaders().append('Content-Type', 'application/json');
//     let url: string = this.coreGymService.BaseUrl!;
//     url = url + this.coreGymService.serviceUrls!['LoginUrl'];

//     // The modern backend expects plain JSON. If you keep the legacy Base64 endpoint
//     // (GetABGTechnologysAccountLogin), Base64-encode email/password here instead.
//     const body = { email, password, rememberMe };
//     // return this.http.post(url,JSON.stringify(body), { headers })
//     //   .pipe(map((data: any) => data, (_error: HttpErrorResponse) => { }));

//      return this.http.post(url, body, { headers })
//        .pipe(catchError((e: HttpErrorResponse) => throwError(() => e)));
//   }

//   sendOtp(channel: 'email' | 'mobile', target: string): Observable<any> {
//     let url: string = this.coreGymService.BaseUrl!;
//     url = url + this.coreGymService.serviceUrls!['SendOtpUrl'];
//     const headers = new HttpHeaders().append('Content-Type', 'application/json');
//     const body = { target, channel: channel === 'mobile' ? 'Sms' : 'Email', purpose: 'Login2fa' };
//     return this.http.post(url, JSON.stringify(body), { headers })
//       .pipe(catchError((e: HttpErrorResponse) => throwError(() => e)));
//   }

//   verifyOtp(challengeToken: string, code: string, rememberMe: boolean = false): Observable<any> {
//     let url: string = this.coreGymService.BaseUrl!;
//     url = url + this.coreGymService.serviceUrls!['VerifyOtpUrl'];
//     const headers = new HttpHeaders().append('Content-Type', 'application/json');
//     const body = { challengeToken, code, rememberMe };
//     return this.http.post(url, JSON.stringify(body), { headers })
//       .pipe(catchError((e: HttpErrorResponse) => throwError(() => e)));
//   }

//   requestPasswordReset(target: string, channel: 'Email' | 'Sms' | 'WhatsApp' = 'Email'): Observable<any> {
//     let url: string = this.coreGymService.BaseUrl!;
//     url = url + this.coreGymService.serviceUrls!['ForgotPasswordUrl'];
//     const headers = new HttpHeaders().append('Content-Type', 'application/json');
//     return this.http.post(url, JSON.stringify({ target, channel }), { headers })
//       .pipe(catchError((e: HttpErrorResponse) => throwError(() => e)));
//   }

//   resetPassword(target: string, code: string, newPassword: string): Observable<any> {
//     let url: string = this.coreGymService.BaseUrl!;
//     url = url + this.coreGymService.serviceUrls!['ResetPasswordUrl'];
//     const headers = new HttpHeaders().append('Content-Type', 'application/json');
//     return this.http.post(url, JSON.stringify({ target, code, newPassword }), { headers })
//       .pipe(catchError((e: HttpErrorResponse) => throwError(() => e)));
//   }
// }


import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CoreGymService } from '../core.gym.service.service';

/**
 * LoginService (domainservice copy) — this is the exact same service as
 * NewLogin_RelatedFile/Login/Login.Service.ts, relocated to
 * _services/domainservice/login.service.ts so Login.ts's
 * `import { LoginService } from '../_services/domainservice/login.service'`
 * (1 level up from NewLogin_RelatedFile/Login/, per the normalized import-depth
 * scheme documented in Login.ts/Header.ts) resolves to a real file.
 *
 * The `'../core.gym.service.service'` import below is unchanged from the original
 * Login/Login.Service.ts copy: that file already sat 1 level up from
 * NewLogin_RelatedFile/Login/ to reach _services/core.gym.service.service.ts, and
 * _services/domainservice/ is *also* exactly 1 level up from
 * _services/core.gym.service.service.ts — so the same relative path happens to
 * resolve correctly at this new location without modification.
 *
 * If your real app already has a login.service.ts, delete this file and drop the
 * real one in at this path (or repoint Login.ts's import).
 */
@Injectable({ providedIn: 'root' })
export class LoginService {

  constructor(
    private readonly http: HttpClient,
    private readonly coreGymService: CoreGymService
  ) { }

  /** POST /api/auth/login -> { accessToken, refreshToken, user }.
   *  captchaToken (Task #45) is optional — LoginRequest.CaptchaToken is a trailing nullable param
   *  server-side, and CaptchaVerifier.cs short-circuits to success while Captcha:Enabled=false, so
   *  omitting/passing null here is safe against an unconfigured backend. */
  login(email: string, password: string, rememberMe: boolean = false, captchaToken: string | null = null): Observable<any> {
    const headers = new HttpHeaders().append('Content-Type', 'application/json');
    let url: string = this.coreGymService.BaseUrl!;
    url = url + this.coreGymService.serviceUrls!['LoginUrl'];

    const body = { email, password, rememberMe, captchaToken };
    return this.http.post(url, body, { headers })
      .pipe(catchError((e: HttpErrorResponse) => throwError(() => e)));
  }

  // Task #55: Google/Microsoft OAuth login. idToken/accessToken are the provider-supplied tokens
  // Login.ts's Google Identity Services / MSAL SDK integration produces client-side — see that
  // file's loginWithGoogle/loginWithMicrosoft handlers. Same response shape as login() above
  // (TokenResponse) on success; AuthController.cs's OAuthGoogle/OAuthMicrosoft actions map every
  // LoginOutcome (including the two new OAuth-specific ones) through the same MapLoginResult switch
  // login() itself goes through, so Login.ts's existing `err.error.code` handling extends to these
  // two new codes (NO_ACCOUNT_LINKED, OAUTH_UNAVAILABLE) without needing new plumbing.
  /** POST api/auth/oauth/google -> { accessToken, refreshToken, user }. */
  loginWithGoogle(idToken: string, rememberMe: boolean = false): Observable<any> {
    const headers = new HttpHeaders().append('Content-Type', 'application/json');
    let url: string = this.coreGymService.BaseUrl!;
    url = url + this.coreGymService.serviceUrls!['OAuthGoogleLoginUrl'];
    const body = { idToken, rememberMe };
    return this.http.post(url, body, { headers })
      .pipe(catchError((e: HttpErrorResponse) => throwError(() => e)));
  }

  /** POST api/auth/oauth/microsoft -> { accessToken, refreshToken, user }. */
  loginWithMicrosoft(accessToken: string, rememberMe: boolean = false): Observable<any> {
    const headers = new HttpHeaders().append('Content-Type', 'application/json');
    let url: string = this.coreGymService.BaseUrl!;
    url = url + this.coreGymService.serviceUrls!['OAuthMicrosoftLoginUrl'];
    const body = { accessToken, rememberMe };
    return this.http.post(url, body, { headers })
      .pipe(catchError((e: HttpErrorResponse) => throwError(() => e)));
  }

  refresh(refreshToken: string): Observable<any> {
    const headers = new HttpHeaders().append('Content-Type', 'application/json');
    let url: string = this.coreGymService.BaseUrl!;
    url = url + this.coreGymService.serviceUrls!['RefreshUrl'];
    return this.http.post(url, { refreshToken }, { headers })
      .pipe(catchError((e: HttpErrorResponse) => throwError(() => e)));
  }


  // FIXED (Login-Test-Report.md Issue re: HTTP verb mismatch): sendOtp/verifyOtp/requestPasswordReset
  // originally POSTed a JSON body to these URLs. The real backend
  // (Login/ABGTechnologysAccountsController.cs) exposes all three as [HttpGet] actions reading
  // [FromQuery] parameters — a POST would 404/405 against the real controller. Switched to GET +
  // HttpParams below, with parameter names matching the real action signatures exactly.

  /** GET api/ABGTechnologysAccounts/SendOtp?channel=..&target=..
   *  Real action: SendOtp([FromQuery] string channel, [FromQuery] string target). channel accepts
   *  "email"/"sms"/"mobile"/"whatsapp" (case-insensitive, see MapChannel in the real controller) —
   *  passed through as-is, no client-side remapping needed. */
  sendOtp(channel: 'email' | 'mobile', target: string): Observable<any> {
    let url: string = this.coreGymService.BaseUrl!;
    url = url + this.coreGymService.serviceUrls!['SendOtpUrl'];
    const params = new HttpParams().set('channel', channel).set('target', target);
    return this.http.get(url, { params })
      .pipe(catchError((e: HttpErrorResponse) => throwError(() => e)));
  }

  /** GET api/ABGTechnologysAccounts/VerifyOtp?target=..&code=..
   *  Real action: VerifyOtp([FromQuery] string target, [FromQuery] string code) — confirms a code
   *  sent to `target` (email or phone). This is generic contact verification (registration / forgot
   *  password), NOT the login page's 2FA flow — see completeTwoFactor() below for that. */
  verifyOtp(target: string, code: string): Observable<any> {
    let url: string = this.coreGymService.BaseUrl!;
    url = url + this.coreGymService.serviceUrls!['VerifyOtpUrl'];
    const params = new HttpParams().set('target', target).set('code', code);
    return this.http.get(url, { params })
      .pipe(catchError((e: HttpErrorResponse) => throwError(() => e)));
  }

  // FIXED (Login-Test-Report.md Section 7.4 gap): AuthController's login action mints a
  // `challengeToken` whenever it returns `REQUIRES_2FA`, and Login.ts already forwards it to
  // /verify-otp — but no endpoint consumed it to finish the sign-in. RecoveryService.CompleteTwoFactorAsync
  // was already fully implemented server-side (validates the challenge token + OTP, then mints the
  // real TokenResponse); this method is the new POST api/ABGTechnologysAccounts/CompleteTwoFactor
  // wiring for it. Returns the same TokenResponse shape as login() on success.
  /** POST api/ABGTechnologysAccounts/CompleteTwoFactor -> { accessToken, refreshToken, user }. */
  completeTwoFactor(challengeToken: string, code: string, rememberMe: boolean = false): Observable<any> {
    const headers = new HttpHeaders().append('Content-Type', 'application/json');
    let url: string = this.coreGymService.BaseUrl!;
    url = url + this.coreGymService.serviceUrls!['CompleteTwoFactorUrl'];
    const body = { challengeToken, code, rememberMe };
    return this.http.post(url, body, { headers })
      .pipe(catchError((e: HttpErrorResponse) => throwError(() => e)));
  }

  /** GET api/ABGTechnologysAccounts/RequestPasswordReset?EmailId=..
   *  Real action: RequestPasswordReset([FromQuery] string EmailId) — always sends via email
   *  regardless of any requested channel (SendForgotPasswordOtpAsync hardcodes OtpChannel.Email
   *  server-side); the `channel` parameter here is accepted for forward-compatibility but is not
   *  currently honored by the real endpoint. Always returns 200 (never reveals account existence). */
  requestPasswordReset(target: string, channel: 'Email' | 'Sms' | 'WhatsApp' = 'Email'): Observable<any> {
    let url: string = this.coreGymService.BaseUrl!;
    url = url + this.coreGymService.serviceUrls!['ForgotPasswordUrl'];
    const params = new HttpParams().set('EmailId', target);
    void channel; // accepted for API shape stability; not honored by the real endpoint today
    return this.http.get(url, { params })
      .pipe(catchError((e: HttpErrorResponse) => throwError(() => e)));
  }

  resetPassword(target: string, code: string, newPassword: string): Observable<any> {
    let url: string = this.coreGymService.BaseUrl!;
    url = url + this.coreGymService.serviceUrls!['ResetPasswordUrl'];
    const headers = new HttpHeaders().append('Content-Type', 'application/json');
    return this.http.post(url, JSON.stringify({ target, code, newPassword }), { headers })
      .pipe(catchError((e: HttpErrorResponse) => throwError(() => e)));
  }

  /** POST api/auth/change-password (requires the bearer token AuthInterceptor already attaches).
   *  Task #46: used by ChangePasswordRequiredComponent for the forced-first-login-password-change
   *  flow — same real, [Authorize] AuthController.ChangePassword action already used by any other
   *  "already signed in, rotate my password" screen. */
  changePassword(currentPassword: string, newPassword: string): Observable<any> {
    let url: string = this.coreGymService.BaseUrl!;
    url = url + this.coreGymService.serviceUrls!['ChangePasswordUrl'];
    const headers = new HttpHeaders().append('Content-Type', 'application/json');
    return this.http.post(url, { currentPassword, newPassword }, { headers })
      .pipe(catchError((e: HttpErrorResponse) => throwError(() => e)));
  }
}

